// extracted by mini-css-extract-plugin
export var image = "ck_dc";